import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatError } from "../api";
import { Skull } from "lucide-react";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const [email, setEmail] = useState("admin@chibah.com");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  if (loading) return <div className="py-24 text-center font-mono text-xs uppercase tracking-[0.3em]">Checking the rolls…</div>;
  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e) {
      setErr(formatError(e?.response?.data?.detail) || "Login failed.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-bone flex items-center justify-center px-5 py-20" data-testid="admin-login-page">
      <form onSubmit={onSubmit} className="w-full max-w-md border-4 border-asphalt bg-card-light shadow-hard-lg p-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 border-2 border-asphalt bg-terra flex items-center justify-center shadow-hard">
            <Skull className="w-6 h-6 text-bone" />
          </div>
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.3em]">Restricted</div>
            <div className="font-display text-3xl uppercase tracking-tight">Boss Door</div>
          </div>
        </div>
        <label className="block font-mono text-[10px] uppercase tracking-[0.3em] mb-2">Email</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="admin-login-email"
          className="w-full px-4 py-3 border-2 border-asphalt bg-bone font-body mb-4"
        />
        <label className="block font-mono text-[10px] uppercase tracking-[0.3em] mb-2">Password</label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          data-testid="admin-login-password"
          className="w-full px-4 py-3 border-2 border-asphalt bg-bone font-body mb-6"
        />
        {err && (
          <div className="border-2 border-terra bg-terra/10 text-terra px-3 py-2 font-mono text-xs mb-4" data-testid="admin-login-error">
            {err}
          </div>
        )}
        <button
          type="submit"
          disabled={busy}
          data-testid="admin-login-submit"
          className="w-full bg-asphalt text-bone border-2 border-asphalt px-6 py-3 font-display tracking-wider uppercase text-xl shadow-hard hover:bg-terra transition-colors disabled:opacity-50"
        >
          {busy ? "Knocking…" : "Enter"}
        </button>
      </form>
    </div>
  );
}
